module.exports = __webpack_public_path__ + "static/media/noun_Close_3039071.e2e49522.svg";